export const quotesData = [
  {
    id: 1,
    author: "Craig Bruce",
    quote:
      "It's hardware that makes a machine fast.  It's software that makes a fast machine slow",
  },
  {
    id: 2,
    author: "Bill Gates",
    quote:
      " The computer was born to solve problems that did not exist before ",
  },
  {
    id: 3,
    author: "Edsger W. Dijkstra",
    quote:
      " Computer Science is no more about computers than astronomy is about telescopes ",
  },
  {
    id: 4,
    author: "Emo Philips",
    quote:
      "A computer once beat me at chess, but it was no match for me at kick boxing",
  },

  {
    id: 5,
    author: "Isaac Asimov",
    quote:"I do not fear computers. I fear lack of them",
  }
];
